import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../../styles.module.scss'
import { useTranslation } from 'react-i18next'
import EmptyCard from '../../common/EmptyCard'
import CardSubTitle from '../../common/CardSubTitle'
import Button from 'srcReact/components/common2/Button'
import Modal from 'srcReact/components/common2/Modal'
import TooltipWrapper from 'srcReact/components/common2/TooltipWrapper'
import Pill from 'srcReact/components/common2/Pill'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'srcReact/helpers/validator'
import ConfirmModal from 'srcReact/components/common2/ConfirmModal'
import { createUpdateGroupActions } from 'srcReact/GroupPage'
import Icon from 'srcReact/components/icons/Icon'

function MostPopularInterests({ type, groupType, sectionType, objectId, interests }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const showInterestCount = 5
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isAddInterestModalOpen, setIsAddInterestModalOpen] = useState(false)
  const [interestToAdd, setInterestToAdd] = useState(null)

  const {
    createUpdateGroup: { editSuccess, loading: addInterestLoading },
    dashboardDetail: { data }
  } = useSelector((state) => state)

  useEffect(() => {
    if (editSuccess && !addInterestLoading) {
      closeAddInterestModal()
    }
  }, [addInterestLoading, editSuccess])

  const showModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }

  const showAddInterestModal = (interest) => {
    setIsAddInterestModalOpen(true)
    setInterestToAdd(interest)
  }
  const closeAddInterestModal = () => {
    setIsAddInterestModalOpen(false)
    setInterestToAdd(null)
  }

  const handleAddInterest = () => {
    const existingInterests = data?.group_info?.interests ? data.group_info.interests : []
    const newInterests = [interestToAdd, ...existingInterests]
    const selectedInterstsIds = newInterests ? newInterests.map((i) => i.id).join(',') : ''
    dispatch(createUpdateGroupActions.editGroup(objectId, { interest_ids: selectedInterstsIds }))
  }

  const getList = (n, fromModal) => {
    const nInterests =
      interests?.length > 0
        ? interests.filter((pair, i) => {
            if (n === -1) {
              return true
            }
            return i < n
          })
        : []

    return (
      <div className={`${styles.list} ${fromModal && styles.listFromModal}`}>
        {nInterests.length > 0 &&
          nInterests.map((interest) => {
            const isGroupInterest = data?.group_info?.interests?.find((i) => i.id === interest.interest_info.id)
            return (
              <div className={styles.listItem} key={interest.interest_info.id}>
                <TooltipWrapper
                  content={interest.interest_info.name}
                  triggerElement={
                    <Pill
                      text={interest.interest_info.name}
                      className={styles.interest}
                      selected={!isEmpty(isGroupInterest)}
                      {...(!isGroupInterest && type === 'group'
                        ? {
                            onClick: () => showAddInterestModal(interest.interest_info)
                          }
                        : {})}
                    />
                  }
                />
                <p className={styles.percent}>{`${interest.value}%`}</p>
              </div>
            )
          })}

        {interests?.length > showInterestCount && !fromModal && (
          <button className={parentStyles.seeAll} onClick={showModal}>
            <span>
              {groupType === 'expertise'
                ? t('dashboard.expertiseInsights.seeAllExpertises')
                : t('dashboard.interestInsights.seeAllInterests')}
            </span>{' '}
            <Icon name='arrow-right' size='x-small' />
          </button>
        )}
      </div>
    )
  }

  return (
    <div className={`${parentStyles.card} ${styles.popularInterests}`}>
      <CardSubTitle
        titleStyle={styles.title}
        title={
          sectionType === 'popular' && groupType === 'expertise'
            ? t('dashboard.expertiseInsights.mostPopular.text')
            : sectionType === 'popular'
            ? t('dashboard.interestInsights.mostPopular.text')
            : t('dashboard.interestInsights.popularInterestsWithNoAssociatedGroups.title')
        }
        onClick={showModal}
      />
      {interests?.length > 0 ? (
        getList(showInterestCount, false)
      ) : (
        <EmptyCard
          contentTitle={t('dashboard.interestInsights.mostPopular.empty.title')}
          contentText={t('dashboard.interestInsights.mostPopular.empty.text')}
          contentImage='showcasing'
          buttonStyle='is-bordered'
          contentButton={t('global.inviteMembers')}
          contentButtonLink={`/0/group/${objectId}/invite-members`}
          linkTarget='_blank'
        />
      )}
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          handleClose={closeModal}
          title={
            groupType === 'expertise'
              ? t('dashboard.expertiseInsights.mostPopular.text')
              : t('dashboard.interestInsights.mostPopular.text')
          }>
          {getList(-1, true)}
          <Button text={t('global.done')} customStyle={styles.doneButton} handleClick={closeModal} />
        </Modal>
      )}
      {isAddInterestModalOpen && (
        <ConfirmModal
          isOpen={isAddInterestModalOpen}
          closeModal={closeAddInterestModal}
          title={t('dashboard.interestInsights.addInterest', {
            interest: interestToAdd?.name
          })}
          hasTitleHTML={true}
          handlePrimaryButton={handleAddInterest}
          handleSecondaryButton={closeAddInterestModal}
          loading={addInterestLoading}
        />
      )}
    </div>
  )
}

export default MostPopularInterests
